import { Injectable, inject } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { OpportunityLinksService } from '@/services/opportunity-links.service';
import * as OpportunityLinksActions from './opportunity-links.actions';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class OpportunityLinksEffects {
  private actions$ = inject(Actions);
  private service = inject(OpportunityLinksService);

  loadLinks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OpportunityLinksActions.loadOpportunityLinks),
      switchMap((action) =>
        this.service.getLinks(action.opportunityId).pipe(
          map((links) => OpportunityLinksActions.loadOpportunityLinksSuccess({ links })),
          catchError((error) => of(OpportunityLinksActions.loadOpportunityLinksFailure({ error })))
        )
      )
    )
  );

  createLink$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OpportunityLinksActions.createOpportunityLink),
      mergeMap((action) =>
        this.service.createLink(action.opportunityId, action.dto).pipe(
          map((link) => OpportunityLinksActions.createOpportunityLinkSuccess({ link })),
          catchError((error) => of(OpportunityLinksActions.createOpportunityLinkFailure({ error })))
        )
      )
    )
  );

  updateLink$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OpportunityLinksActions.updateOpportunityLink),
      mergeMap((action) =>
        this.service.updateLink(action.linkId, action.dto).pipe(
          map((link) => OpportunityLinksActions.updateOpportunityLinkSuccess({ link })),
          catchError((error) => of(OpportunityLinksActions.updateOpportunityLinkFailure({ error })))
        )
      )
    )
  );

  deleteLink$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OpportunityLinksActions.deleteOpportunityLink),
      mergeMap(({ link }) =>
        this.service.deleteLink(link.id).pipe(
          map(() => OpportunityLinksActions.deleteOpportunityLinkSuccess({ link })),
          catchError((error) => of(OpportunityLinksActions.deleteOpportunityLinkFailure({ error })))
        )
      )
    )
  );
}
